import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }


import { computed, defineAsyncComponent } from 'vue';
import { useStore } from 'vuex';
import { NAME as EXPLORER } from '@shell/config/product/explorer';
import { canViewResource } from '@shell/utils/auth';

// Loaded when first used, formatters are all registered when the app starts
const ResourcePopover = defineAsyncComponent(() => import('@shell/components/Resource/Detail/ResourcePopover/index.vue'));

/**
 * Like LinkName for a resource that isn't namespaced, but the link also opens a popover with the details of the resource.
 * The resource is only fetched when the user hovers or focuses the link, so it can be used in a table
 */
export interface Props {
  /**
   * The name of the resource
   */
  value?: string;
  type: string;
}

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'LinkNamePopover',
  props: {
    value: { default: '' },
    type: {}
  },
  setup(__props: any) {

// A table also passes the row, column and other values that shouldn't end up as attributes on the link


const props = __props;
const store = useStore();

// The same route as LinkName
const detailLocation = computed(() => ({
  name:   'c-cluster-product-resource-id',
  params: {
    cluster:  store.getters['clusterId'],
    product:  store.getters['productId'] || EXPLORER,
    resource: props.type,
    id:       props.value,
  }
}));

const canView = computed(() => canViewResource(store, props.type));

return (_ctx: any,_cache: any) => {
  return (props.value && canView.value)
    ? (_openBlock(), _createBlock(_unref(ResourcePopover), {
        key: 0,
        id: props.value,
        type: props.type,
        name: props.value,
        "detail-location": detailLocation.value,
        "show-status": false,
        lazy: "",
        "wrap-name": ""
      }, null, 8, ["id", "type", "name", "detail-location"]))
    : (props.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.value), 1))
      : _createCommentVNode("", true)
}
}

})